import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "my-16" }
const _hoisted_2 = { class: "my-8" }
const _hoisted_3 = { class: "my-16" }
const _hoisted_4 = { class: "my-8" }
const _hoisted_5 = { class: "my-16" }
const _hoisted_6 = { class: "my-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_chip = _resolveComponent("v-chip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[14] || (_cache[14] = _createElementVNode("h1", null, "Collaborations", -1)),
    _createElementVNode("div", _hoisted_1, [
      _cache[3] || (_cache[3] = _createElementVNode("h2", null, [
        _createElementVNode("a", { href: "https://typeqast.com/" }, " Typeqast ")
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_v_chip, {
          outlined: "",
          class: "mr-2 mb-2"
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode("Laravel", -1)
          ])),
          _: 1,
          __: [0]
        }),
        _createVNode(_component_v_chip, {
          outlined: "",
          class: "mr-2 mb-2"
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode("Symfony", -1)
          ])),
          _: 1,
          __: [1]
        }),
        _createVNode(_component_v_chip, {
          outlined: "",
          class: "mr-2 mb-2"
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode("Vue.js", -1)
          ])),
          _: 1,
          __: [2]
        })
      ]),
      _cache[4] || (_cache[4] = _createElementVNode("p", { class: "my-8" }, [
        _createTextVNode(" Architecting and Developing ERP systems for International Clients,"),
        _createElementVNode("br"),
        _createTextVNode(" as well as building internal apps for the Company. ")
      ], -1))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[7] || (_cache[7] = _createElementVNode("h2", null, [
        _createElementVNode("a", { href: "https://microblink.com/" }, " Microblink ")
      ], -1)),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_v_chip, {
          outlined: "",
          class: "mr-2 mb-2"
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [
            _createTextVNode("Spring Boot", -1)
          ])),
          _: 1,
          __: [5]
        }),
        _createVNode(_component_v_chip, {
          outlined: "",
          class: "mr-2 mb-2"
        }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [
            _createTextVNode("JavaScript", -1)
          ])),
          _: 1,
          __: [6]
        })
      ]),
      _cache[8] || (_cache[8] = _createElementVNode("p", { class: "my-8" }, [
        _createTextVNode(" Building internal systems and public-facing apps"),
        _createElementVNode("br"),
        _createTextVNode(" to support main operations of the Company. ")
      ], -1))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _cache[12] || (_cache[12] = _createElementVNode("h2", null, [
        _createElementVNode("a", { href: "https://www.humaninteraction.com/" }, " Human Interaction ")
      ], -1)),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_v_chip, {
          outlined: "",
          class: "mr-2 mb-2"
        }, {
          default: _withCtx(() => _cache[9] || (_cache[9] = [
            _createTextVNode("Angular 2", -1)
          ])),
          _: 1,
          __: [9]
        }),
        _createVNode(_component_v_chip, {
          outlined: "",
          class: "mr-2 mb-2"
        }, {
          default: _withCtx(() => _cache[10] || (_cache[10] = [
            _createTextVNode("Node.js", -1)
          ])),
          _: 1,
          __: [10]
        }),
        _createVNode(_component_v_chip, {
          outlined: "",
          class: "mr-2 mb-2"
        }, {
          default: _withCtx(() => _cache[11] || (_cache[11] = [
            _createTextVNode("Symfony", -1)
          ])),
          _: 1,
          __: [11]
        })
      ]),
      _cache[13] || (_cache[13] = _createElementVNode("p", { class: "my-8" }, " Working on Frontend and Backend projects for Brands mainly from the SEE region. ", -1))
    ])
  ]))
}